import { getRebrandVersion, type RebrandVersion } from 'lib/theme/paletteVersion'

/** Resolves the palette from static brand configuration, independently of consent. */
function useRebrandVersion(): RebrandVersion {
  return getRebrandVersion()
}

export default useRebrandVersion
